import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import { Divider, Col, Row } from 'antd'
import Button from 'components/Button/index'

export const PaddedDiv = styled(Flex)`
  padding: 20px 25px;
  gap: 25px;
`
export const SectionWrapper = styled(Flex)`
  width: 100%;
  overflow: scroll;
  height: calc(100vh - 142px);
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: '';
  }
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  font-size: ${FONT.F_3XL};
`
export const RoleNameFlex = styled(Flex)``
export const TopEndFlex = styled(Flex)`
  gap: ${props => (props?.gap ? props?.gap : '0')};
`
export const RoleNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  color: ${COLORS.GREY_T_20};
  margin-right: 10px;
  text-transform: capitalize;
`
export const CreateDriveButton = styled(Button.Primary)`
  width: 153px;
  color: #ffffff !important;
  background: #3249d7 !important;
`
export const DrivesButton = styled(Button.Secondary)`
  font-weight: ${FONT.FW_600};
`
export const CalenderFlex = styled(Flex)`
  align-items: center;
  padding: 8px 15px;
  width: 86px;
  height: 38px;
  border: 1px solid ${COLORS.GREY_T_90};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 10px;
  margin: 0 15px;
  cursor: ${props => (props.active ? 'pointer' : 'not-allowed')};
`
export const CalenderCount = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  padding: 9px 6px;
  color: ${COLORS.WHITE};
  width: 27px;
  height: 19px;
  background: ${props => (props.active ? COLORS.RED_S2_100 : COLORS.GREY_T_80)};
  border-radius: 10px;
  margin: 5px;
`

export const ActionsDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  color: ${COLORS.GREY_T_60};
  margin-left: 5px;
`
export const LeftSection = styled(Flex)`
  gap: 20px;
`
export const SectionName = styled(Flex)`
  gap: 10px;
`
export const ShareWrap = styled(Flex)`
  border: 1px solid ${COLORS.GREY_T_90};
  padding: 25px;
  border-radius: 10px;
`
export const ShareSection = styled(Flex)`
  border: 1px solid ${COLORS.GREY_T_90};
  padding: 10px 14px 10px 20px;
  border-radius: 10px;
  background-color: ${COLORS.PRIMARY_GREY_T_98};
  margin-top: 8px;
  cursor: pointer;
  path {
    transition: 0.5s;
  }
  :hover {
    translate: 1.01;
    path {
      fill: ${COLORS.PRIMARY};
    }
  }
`
export const LinkText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 0;
`
export const ShareLink = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_BASE};
  line-height: 24px;
  margin-bottom: 0;
  color: ${COLORS.GREY_T_20};
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
export const AddSameDriveButton = styled(Button.Secondary)`
  box-shadow: none !important;
  background: transparent !important;
  border: none !important;
  font-weight: ${FONT.FW_600};
`
export const AlertFlex = styled(Flex)`
  gap: 5px;
`
export const OuterDiv = styled.div`
  border: 1px solid ${COLORS.PAGE_BORDER};
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  margin: 30px 100px 20px 100px;
  border-radius: 10px;
`

export const TopNav = styled(Flex)`
  height: 160px;
  background-color: #fafafb;
  padding: 30px;
  flex-direction: column;
`

export const TitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_700)};
  font-size: ${FONT.F_2XL};
  line-height: 30px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 0;
`
export const SubtitleLarge = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  padding-left: 10px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: 5px;
`
export const GrayTextSmall = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 30px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
`

export const InfoText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  line-height: 30px;
  color: ${COLORS.GREY_T_50_2};
  margin-bottom: 0;
  margin-left: ${props => (props.marginleft ? props.marginleft : '0px')};
  word-wrap: break-word;
`

export const YellowBox = styled(Flex)`
  padding: 10px;
  background: ${COLORS.ORANGE_T_92};
  border: 1px solid ${COLORS.ORANGE_T_60};
  border-radius: 10px;
  gap: 15px;
`

export const FlexWrap = styled(Flex)`
  position: relative;
  gap: ${props => (props.gap ? props.gap : '0px')};
  padding: ${props => (props.padding ? props.padding : '0px')};
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};
`
export const GrayText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
  margin-bottom: 0;
`

export const SubtitleSmall = styled.p`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_400)};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_SM)};
  line-height: 20px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '5px')};
  span {
    font-style: normal;
    font-weight: ${FONT.FW_600};
    line-height: 18px;
    color: ${COLORS.GREY_T_10};
    margin-right: 5px;
  }
`

export const SubtitleMedium = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_10};
  margin-bottom: 0;
`

export const VerticalDivider = styled(Divider)`
  height: 20px;
`

export const FlexContain = styled(Flex)`
  padding: 15px 0px;
`

export const LeftCol = styled(Col)`
  padding: 10px;
`
export const Editor = styled.div`
  width: 75%;
  padding: 10px;
`
export const Address = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
`
export const NameAdd = styled(Flex)`
  gap: 3px;
  padding-left: 15px;
`
export const Container = styled(Flex)`
  padding-right: 20px;
`
export const Name = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #343e59;
`
export const BreadCrumns = styled.div`
  display: flex;
`
export const RowContainer = styled(Row)`
  padding: 20px;
`

export const EditorContent = styled.span`
  padding: 20px 0;
  * {
    line-height: 188%;
    color: #808697 !important;
  }
  p,
  ul,
  ol {
    margin-bottom: 10px;
  }

  li {
    line-height: 25px;
  }
`
export const PopHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
  padding-top: 15px;
`
export const PopSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #808697;
  padding-top: 5px;
`
export const Name1 = styled.div`
  font-weight: 600;
  font-size: 16px;
  height: 24px;
  line-height: 22px;
  text-align: center;
  color: #343e59;
`
export const Address1 = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
`
export const Frame = styled.div`
  padding: 20px;
`
export const ShareTitile = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #343e59;
`
export const RowListIcon = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
`
export const ColListIcon = styled(Flex)`
  gap: 10x;
  cursor: pointer;
`

export const RowListLabel = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #343e59;
`

export const DropRow = styled(Row)`
  width: 470px;
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 10px;
  outline: none;
  box-shadow: 0px 2px 10px rgb(99 116 135 / 20%);
`

export const CenteredDiv = styled.div`
  width: 100%;
  padding: 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #3d5a8080;
`
export const Content = styled(Flex)`
  height: auto;
  width: 100%;
  gap: 20px;
  border-radius: 10px;
  padding-bottom: 10px;
`

export const MailHeading = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  color: #010e30;
`

export const MailSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #4d566e;
`
export const DisplayPad = styled.div`
  width: 100%;
  padding: 20px 0px;
`
export const RowPadding = styled(Row)`
  padding: 15px;
`
